import { render, staticRenderFns } from "./TermDetail.vue?vue&type=template&id=4d8bae5c&scoped=true&"
import script from "./TermDetail.vue?vue&type=script&lang=js&"
export * from "./TermDetail.vue?vue&type=script&lang=js&"
import style0 from "./TermDetail.vue?vue&type=style&index=0&id=4d8bae5c&scoped=true&lang=scss&"
import style1 from "./TermDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8bae5c",
  null
  
)

export default component.exports